import React from 'react';

/**
 * In the V3 UI, we allow for entity apps to be "Popped up"
 * - In our other versions, we expect this content to be oppened in a new tab
 */
const PopupEntityAppContext = React.createContext<
  | undefined
  | {
      poppedUpApp: {
        app: EntityDetails.App;
        entity: EntityDetails.Entity;
        entityValue: string;
      };
      selectedEntity: EntityDetails.SelectedEntity;
      closeEntityPopup: () => void;
    }
>(undefined);

export default PopupEntityAppContext;
